import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { getLink } from '../../assets/js/genericHelpers';

const SquareIcon = () => {
  return <div className={`perfomanceSquareIcon`}></div>;
};

const CircleIcon = () => {
  return <div className={`perfomanceCircleIcon`}></div>;
};

const TriangleIcon = () => {
  return <div className={`perfomanceTriangleIcon`}></div>;
};

const PerformanceLabData = ({ data, url }) => {
  console.log("url",url);
  const dispatch = useDispatch();
  const openExternalLink = () => {
    window.open(
      `https://developers.google.com/speed/pagespeed/insights/?url=${url}`,
    );
  };
  const openExternalByParam = (content) => {
    const link = getLink(content);
    if (!!link.url && link.url.length > 0) {
      window.open(link.url);
    }
  };

  return (
    <Col className={`mt-5 fw-6 p-0`}>
      <Col className={`text-size-25 color-indigo-900 mb-4 fw-5 p-0`}>
        Lab Data
      </Col>
      <Col className={`labContent p-0`}>
        {!!data &&
          data.map((value) => {
            return (
              <div className='d-flex flex-column mb-3 w-50 mainContent'>
                <div className='main'>
                  <div className='d-flex align-items-center'>
                    {value.score * 100 <= 49 ? (
                      <TriangleIcon />
                    ) : value.score * 100 > 49 && value.score * 100 <= 89 ? (
                      <SquareIcon />
                    ) : (
                      <CircleIcon />
                    )}
                    <div className={`labName`}>{value.title}</div>
                  </div>
                  <div className={`labScore`}>
                  {!!value.numericValue ?  `${(value.numericValue / 1000).toFixed(1)} s` : 'Error!'}
                  </div>
                </div>
                <div
                  className={`howToImprove`}
                  onClick={() => {
                    openExternalByParam(value.title);
                  }}
                >
                  How to improve
                </div>
              </div>
            );
          })}
      </Col>
      <Col className='p-0 d-flex col justify-content-end mb-4'>
        <div className='labContentMore' onClick={openExternalLink}>
          More Details
        </div>
      </Col>
    </Col>
  );
};

export { PerformanceLabData, SquareIcon, CircleIcon, TriangleIcon };
